<template>
    <aside class="main-sidebar sidebar-dark-primary elevation-4 ">
    <!-- Brand Logo -->
    <a href="/" class="brand-link text-center">
      <span class="brand-text font-weight-light"><b class="text-warning">FX</b>hanuman</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <img src="/img/avatar/avatar.png" class="img-circle elevation-2" alt="User Image">
        </div>
        <div class="info">
          <b-link href="/profile" class="d-block">{{users.firstName}} {{users.lastName}}</b-link>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item">
            <b-link :class="[currentPage.includes('home') ? activeClass : '','nav-item' ]" href="/" class="nav-link">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Dashboard
              </p>
            </b-link>
          </li>

          
          <li class="nav-item">
            <b-link :class="[currentPage.includes('showproduct') ? activeClass : '','nav-item' ]" href="/product" class="nav-link">
              <i class="nav-icon fab fa-product-hunt"></i>
              <p>
                Product
                <span class="right badge badge-danger">New</span>
              </p>
            </b-link>
          </li>

          <li class="nav-item">
            <b-link :class="[currentPage.includes('article') ? activeClass : '','nav-item' ]" href="/article" class="nav-link">
              <i class="nav-icon fas fa-chalkboard-teacher"></i>
              <p>
                Article
              </p>
            </b-link>
          </li>

          <li class="nav-item">
            <b-link :class="[currentPage.includes('contact') ? activeClass : '','nav-item' ]" href="/contact" class="nav-link">
              <i class="nav-icon fa fa-address-card"></i>
              <p>
                Contact Us
              </p>
            </b-link>
          </li>

          <li class="nav-item">
            <b-link :class="[currentPage.includes('profile') ? activeClass : '','nav-item' ]" href="/profile" class="nav-link">
              <i class="nav-icon fas fa-user"></i>
              <p>
                Profile
              </p>
            </b-link>
          </li>

          <div class="nav-item" v-if="role_active === 'admin'">
          <li class="nav-header">Admin Management</li>
          <li class="nav-item">
            <b-link :class="[currentPage.includes('admin-dashboard') ? activeClass : '','nav-item' ]" href="/admin" class="nav-link">
              <i class="nav-icon fas fa-chart-pie"></i>
              <p>
                Admin Dashboard
              </p>
            </b-link>
          </li>
           </div>


           <li class="nav-item">
            <a href="#" @click="onLogout()" class="nav-link">
              <i class="nav-icon fas fa-power-off"></i>
              <p>
                Logout
              </p>
            </a>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import axios from "axios"
import { mapState } from "vuex"
export default {
  name: "sidebar",
  data(){
    return {
      // Active Link
      activeClass : 'b-link-exact-active-class',
      role_active: [],
      users: {},
    }
  },
  methods: {
    onLogout() {
      axios
        .post("backend/logout")
        .then(response => {
          this.$Progress.start()
          this.$router.push({ name: "login" });
          this.$Progress.finish()
        })
        .catch(error => error.response.data.message);
    },
  },
  computed: {
    currentPage() {
      // Active Link
      return this.$route.name
    },
    
  },

  // เช็ค role ซ่อน-แสดง sidebar admin
  created(){
    axios.get('backend/getUserLogin').then(response => {
      this.role_active = response.data.user.role
      this.users = response.data.user
    }).catch(e => {
      this.errors.push(e)
    })
  },
}
</script>

<style scoped>



</style>